import smoothscroll from "smoothscroll-polyfill";
import Alpine from "alpinejs";

// kick off the polyfill!
smoothscroll.polyfill();
//alpine
window.Alpine = Alpine;
Alpine.start();
